<template>
  <div class="onboarding-card-wrapper" v-if="currentStep < 4">
    <v-card class="onboarding-card" variant="flat">
      <!-- Card Header -->
      <div class="pa-4 border-b d-flex">
        <div
          style="
            width: 44px;
            height: 44px;
            background: #fafafa;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 16px;
            border: 1px solid #e5e7eb;
          "
        >
          <span style="font-size: 24px; padding: 30px">&#128640;</span>
          <!-- <v-icon>mdi-rocket-launch</v-icon> -->
        </div>
        <div>
          <h2 class="text-lg font-semibold text-gray-900 mb-1">Get Started</h2>
          <p class="text-xs text-gray-500">
            Complete your setup and get your content rolling within minutes.
          </p>
        </div>
      </div>

      <div class="px-4 py-2">
        <v-btn
          color="primary"
          variant="flat"
          block
          size="small"
          class="text-xs font-medium"
          @click="$router.push('/onboarding')"
          append-icon="mdi-arrow-right"
        >
          Start onboarding wizard
        </v-btn>
      </div>

      <!-- <v-card-text class="pa-4">
        <div class="d-flex align-center justify-space-between mb-6">
          <div class="d-flex flex-column align-center">
            <div
              :class="[
                'step-indicator',
                {
                  'step-active': currentStep === 1,
                  'step-completed': currentStep > 1,
                },
              ]"
              class="step-circle"
            >
              <span class="text-xs font-medium">1</span>
            </div>
            <span class="text-[10px] text-gray-500 mt-1" style="font-size: 10px"
              >Account</span
            >
          </div>

          <div class="d-flex flex-column align-center">
            <div
              :class="[
                'step-indicator',
                {
                  'step-active': currentStep === 2,
                  'step-completed': currentStep > 2,
                },
              ]"
              class="step-circle"
            >
              <span class="text-xs font-medium">2</span>
            </div>
            <span class="text-[10px] text-gray-500 mt-1" style="font-size: 10px"
              >Categories</span
            >
          </div>

          <div class="d-flex flex-column align-center">
            <div
              :class="[
                'step-indicator',
                {
                  'step-active': currentStep === 3,
                  'step-completed': currentStep > 3,
                },
              ]"
              class="step-circle"
            >
              <span class="text-xs font-medium">3</span>
            </div>
            <span class="text-[10px] text-gray-500 mt-1" style="font-size: 10px"
              >Posts</span
            >
          </div>
        </div>

        <div v-show="currentStep === 1" class="step-content">
          <div class="mb-4">
            <div class="d-flex align-center mb-2">
              <div class="icon-circle mr-2">
                <v-icon size="16" color="primary">mdi-linkedin</v-icon>
              </div>
              <h3 class="text-sm font-semibold text-gray-900">Link account</h3>
            </div>
            <p class="text-xs text-gray-500 mb-3">
              Connect your LinkedInaccount to enable post generation.
            </p>
            <v-btn
              color="primary"
              variant="flat"
              block
              size="small"
              class="text-xs font-medium"
              prepend-icon="mdi-linkedin"
              @click="$router.push('/brand')"
            >
              Connect
            </v-btn>
          </div>
        </div>

        <div v-show="currentStep === 2" class="step-content">
          <div class="mb-4">
            <div class="d-flex align-center mb-2">
              <div class="icon-circle mr-2">
                <v-icon size="16" color="primary">mdi-tag</v-icon>
              </div>
              <h3 class="text-sm font-semibold text-gray-900">
                Create Categories
              </h3>
            </div>
            <p class="text-xs text-gray-500 mb-3">
              Select categories that align with your brand.
            </p>

            <v-btn
              color="primary"
              variant="flat"
              block
              size="small"
              class="text-xs font-medium"
              @click="$router.push('/categories')"
            >
              Create categories
            </v-btn>
          </div>
        </div>

        <div v-show="currentStep === 3" class="step-content">
          <div class="mb-4">
            <div class="d-flex align-center mb-2">
              <div class="icon-circle mr-2">
                <v-icon size="16" color="primary">mdi-message-plus</v-icon>
              </div>
              <h3 class="text-sm font-semibold text-gray-900">
                Generate Posts
              </h3>
            </div>
            <p class="text-xs text-gray-500 mb-3">
              You're all set! Start generating engaging LinkedIn posts.
            </p>

            <v-btn
              color="primary"
              variant="flat"
              block
              size="small"
              class="text-xs font-medium"
              @click="$store.dispatch('startNewPost')"
            >
              Generate your first post
            </v-btn>
          </div>
        </div>
      </v-card-text> -->
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "OnboardingCard",
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      categories: (state) => state.posts.categories,
      posts: (state) => state.posts.posts,
      accounts: (state) => state.accounts.accounts,
    }),
  },
  watch: {
    accounts: {
      handler(newVal) {
        console.log("accounts changed");
        console.log(newVal);
        if (newVal.length > 0) {
          this.currentStep = 2;
        }
      },
      immediate: true,
      deep: true,
    },
    categories: {
      handler(newVal) {
        console.log("categories changed");
        console.log(newVal);
        if (newVal.length > 0 && this.accounts.length > 0) {
          this.currentStep = 3;
        }
      },
      immediate: true,
      deep: true,
    },
    posts: {
      handler(newVal) {
        console.log("posts changed");
        console.log(newVal);
        if (
          newVal.length > 0 &&
          this.categories.length > 0 &&
          this.accounts.length > 0
        ) {
          this.currentStep = 4; // Done
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      currentStep: 1,
      totalSteps: 3,
      selectedCategories: [],
    };
  },
  methods: {
    nextStep() {
      if (this.currentStep < this.totalSteps) {
        this.currentStep++;
      }
    },
    prevStep() {
      if (this.currentStep > 1) {
        this.currentStep--;
      }
    },
    handleConnect() {
      // TODO: Implement LinkedIn connection logic
      this.nextStep();
    },
    handleGenerate() {
      // TODO: Implement post generation logic
      console.log("Generate posts clicked");
    },
    handleSkip() {
      // TODO: Implement skip logic
      console.log("Skip clicked");
    },
  },
};
</script>

<style scoped>
.onboarding-card-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
}

.onboarding-card {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.border-b {
  border-bottom: 1px solid #e5e7eb;
}

.border-t {
  border-top: 1px solid #e5e7eb;
}

.step-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3f4f6;
  color: #9ca3af;
  border: 2px solid #e5e7eb;
  transition: all 0.3s ease;
}

.step-indicator.step-active {
  background: hsl(222.2 47.4% 11.2%);
  color: white;
  border-color: hsl(222.2 47.4% 11.2%);
}

.step-indicator.step-completed {
  background: hsl(221.2 83.2% 53.3%);
  color: white;
  border-color: hsl(221.2 83.2% 53.3%);
}

.step-line {
  height: 2px;
  background: #e5e7eb;
  flex: 1;
  transition: all 0.3s ease;
}

.step-line-completed {
  background: hsl(221.2 83.2% 53.3%);
}

.step-content {
  transition: all 0.3s ease;
}

.icon-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eff6ff;
  border: 2px solid #e5e7eb;
  flex-shrink: 0;
}

.category-checkbox {
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 8px;
  transition: background-color 0.2s ease;
}

.category-checkbox:hover {
  background-color: #f9fafb;
}

.bg-gray-50 {
  background-color: #f9fafb;
}

.text-gray-500 {
  color: #6b7280;
}

.text-gray-700 {
  color: #374151;
}

.text-gray-900 {
  color: #111827;
}

.text-xs {
  font-size: 12px;
}

.text-sm {
  font-size: 14px;
}

.text-lg {
  font-size: 18px;
}

.font-medium {
  font-weight: 500;
}

.font-semibold {
  font-weight: 600;
}
</style>
